<h1 mat-dialog-title>{{ 'common.words.newFolder' | translate }}</h1>

<mat-dialog-content>
  <mat-form-field class="example-full-width">
    <input matInput maxlength="20" placeholder="{{ 'common.words.folderName' | translate }}" [(ngModel)]="folderName">
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>{{ 'common.cta.cancel' | translate }}</button>
  <button mat-raised-button [mat-dialog-close]="folderName" color="primary">{{ 'common.cta.ok' | translate }}</button>
</mat-dialog-actions>